<template>
    <div>
        <v-btn
            small
            @click="showDialog = true">
            TEST FIELD MAPPER
        </v-btn>

        <test-data-dialog
            v-model="showDialog"
            title="Test Field Mapper"
            button-label="Field Mapper"
            :summary-text="summaryText"
            @test="handleTest"
        />
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import TestDataDialog from './TestDataDialog.vue'

export default {
    name: 'TestFieldMapper',
    components: {
        TestDataDialog
    },
    props: {
        integrationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            showDialog: false,
            summaryText: 'Results'
        };
    },
    methods: {
        handleTest({ payload, onSuccess, onError }) {
            if (!this.integrationId) {
                EventBus.$emit('show-error', 'Missing integration id. Please refresh and try again.');
                onError(new Error('Missing integration id'));
                return;
            }

            this.$http
                .post('/api/fieldmappers/test-mapping', {
                    integration_id: this.integrationId,
                    source_data: payload
                })
                .then(({ data }) => {
                    console.log('API Response:', data);
                    const response = data?.data || data;
                    const machshipPayload = response?.machship_payload || data?.machship_payload;
                    const stats = response?.stats || response || {};
                    const fieldsProcessed = stats.fields_processed || 0;
                    const itemsProcessed = stats.items_processed || 0;
                    
                    const result = JSON.stringify(machshipPayload, null, 2);
                    const summary = (fieldsProcessed === 0 && itemsProcessed === 0) 
                        ? 'Machship Payload Generated'
                        : `${fieldsProcessed} fields processed, ${itemsProcessed} items processed`;
                    
                    this.summaryText = summary;
                    onSuccess(response, result, summary);
                    EventBus.$emit('show-success', 'Test completed successfully');
                })
                .catch((err) => {
                    console.error('API Error:', err);
                    EventBus.$emit('show-error', err);
                    onError(err);
                });
        }
    }
};
</script>

<style scoped>
</style>
